module.exports = __webpack_public_path__ + "static/3-6fe76c06842f19b0f1ef9076013b5e87.png";